export const alertFormKeys = {
  alertUpper: "upper-alert",
  warningUpper: "upper-warning",
  alertLower: "lower-alert",
  warningLower: "lower-warning",
  bid: "bid",
  ask: "ask"
};
